import { NotFoundError } from "@/domain/errors";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { ScheduleDataSource } from "./ScheduleDataSource";
import { ScheduleAvailableTimesResponse } from "@/data/dtos/responses";
import { ScheduleAvailabilityParams } from "@/domain/dtos/params";
import { BlockScheduleDateInput } from "@/domain/dtos/inputs";
import { DaySchedule, ScheduleAvailableDays } from "@/domain/entities";

export class ScheduleRemoteDataSource implements ScheduleDataSource {
  constructor(private readonly api: ApiService) {}

  async getScheduleAvailableDays(
    params: ScheduleAvailabilityParams,
  ): Promise<ScheduleAvailableDays[]> {
    const { data } = await this.api.get<ScheduleAvailableDays[]>(
      Endpoints.available_days,
      params,
    );

    if (!data) throw new NotFoundError("Dias disponíveis");

    return data;
  }

  async getScheduleAvailableTimes(
    params: ScheduleAvailabilityParams,
  ): Promise<ScheduleAvailableTimesResponse[]> {
    const { data } = await this.api.get<ScheduleAvailableTimesResponse[]>(
      Endpoints.available_times,
      params,
    );

    if (!data) throw new NotFoundError("Horários disponíveis");

    return data;
  }

  blockScheduleDate(params: BlockScheduleDateInput): Promise<any> {
    return this.api.post(Endpoints.specific_day_schedules, params);
  }

  async getSpecificDaySchedules(params?: {
    date: string;
  }): Promise<DaySchedule[]> {
    const { data } = await this.api.get<DaySchedule[]>(
      Endpoints.specific_day_schedules,
      params,
    );

    if (!data) {
      return [];
    }

    return data;
  }

  deleteSpecificDaySchedule(id: number): Promise<unknown> {
    return this.api.delete(`${Endpoints.specific_day_schedules}/${id}`);
  }
}
